import { SVGProps } from "react";

const SortIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_192_2514)">
        <path
          d="M0.484745 6.54194H9.21202C9.3079 6.54192 9.40162 6.5134 9.48133 6.45998C9.56105 6.40657 9.62318 6.33066 9.65986 6.24184C9.69655 6.15303 9.70615 6.05531 9.68745 5.96102C9.66876 5.86674 9.62259 5.78013 9.55481 5.71215L5.19117 1.33715C5.14617 1.29199 5.09273 1.25617 5.03392 1.23172C4.9751 1.20728 4.91205 1.1947 4.84838 1.1947C4.78471 1.1947 4.72167 1.20728 4.66285 1.23172C4.60403 1.25617 4.5506 1.29199 4.5056 1.33715L0.141958 5.71215C0.0741711 5.78013 0.0280102 5.86674 0.00931075 5.96102C-0.00938867 6.05531 0.000212908 6.15303 0.0369014 6.24184C0.0735899 6.33066 0.135718 6.40657 0.215432 6.45998C0.295146 6.5134 0.388866 6.54192 0.484745 6.54194Z"
          fill="#04152D"
        />
        <path
          d="M9.21202 9.4585H0.484745C0.388866 9.45852 0.295146 9.48704 0.215432 9.54045C0.135718 9.59387 0.0735899 9.66978 0.0369014 9.75859C0.000212908 9.84741 -0.00938867 9.94513 0.00931075 10.0394C0.0280102 10.1337 0.0741711 10.2203 0.141958 10.2883L4.5056 14.6633C4.5506 14.7084 4.60404 14.7443 4.66285 14.7687C4.72167 14.7931 4.78472 14.8057 4.84838 14.8057C4.91205 14.8057 4.9751 14.7931 5.03391 14.7687C5.09273 14.7443 5.14617 14.7084 5.19117 14.6633L9.55481 10.2883C9.62259 10.2203 9.66876 10.1337 9.68745 10.0394C9.70615 9.94513 9.69655 9.84741 9.65986 9.75859C9.62318 9.66978 9.56105 9.59387 9.48133 9.54045C9.40162 9.48704 9.3079 9.45852 9.21202 9.4585Z"
          fill="#04152D"
        />
      </g>
      <defs>
        <clipPath id="clip0_192_2514">
          <rect
            width="10"
            height="15.5556"
            fill="white"
            transform="translate(0 0.222168)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortIcon;
